import spacingOptions from './spacing-options.esm.js';

var gapOptionList = Object.keys(spacingOptions.gap);
var gapColOptionList = Object.keys(spacingOptions.gapCol);
var gapRowOptionList = Object.keys(spacingOptions.gapRow);
var paddingOptionList = Object.keys(spacingOptions.padding);
var paddingXOptionList = Object.keys(spacingOptions.paddingX);
var paddingYOptionList = Object.keys(spacingOptions.paddingY);

export { gapColOptionList, gapOptionList, gapRowOptionList, paddingOptionList, paddingXOptionList, paddingYOptionList };
//# sourceMappingURL=types.esm.js.map
